import React from 'react';
import parseISO from 'date-fns/parseISO';
import isWithinInterval from 'date-fns/isWithinInterval';
import { Grid, Cell } from 'formlabs-web-components/Grid';
import './NotificationBanner.module.css';

const NotificationBanner = ({ startDate, endDate, message }) => {
  const start = new Date(parseISO(startDate));
  const end = new Date(parseISO(endDate));

  if (!isWithinInterval(Date.now(), { start: start, end: end })) {
    return null;
  }
  return (
    <div role="banner" styleName="banner">
      <Grid direction="x" hasContainer={true}>
        <Cell smallSize={24}>
          <p>{message}</p>
        </Cell>
      </Grid>
    </div>
  );
};

export default NotificationBanner;
